export default __webpack_public_path__ + "static/media/Logo M+.8ce4291f.png";